import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { IROH_SERVICES_API_PREFIX } from "@/api/domain"
import type { Repo } from "@/repos"
import type { ProjectIdParam, Uuid } from "@/types"

type GithubRepo = {
  id: number
  name: string
  full_name: string
  clone_url: string
  default_branch: string
  // owner: GitHubUser,
  // permissions: Option<GitHubPermissions>,
}

type PostProjectRepoParam = {
  project_id: string
  gh_repo_id: string
}

type PostCloneParams = ProjectIdParam & {
  source_owner: string
  source_repo: string
  new_repo_name?: string
}

// Define a service using a base URL and expected endpoints
export const githubApi = createApi({
  reducerPath: "github",
  baseQuery: fetchBaseQuery({
    baseUrl: `${IROH_SERVICES_API_PREFIX}github`,
    mode: "cors",
    credentials: "include",
  }),
  endpoints: (build) => ({
    getGithubRepositories: build.query<GithubRepo[], { user_id: Uuid }>({
      query: (body) => ({
        url: `repositories?user_id=${body.user_id}`,
      }),
    }),
    postProjectGithubRepo: build.mutation<Repo, PostProjectRepoParam>({
      query: (body) => ({
        url: `${body.project_id}/${body.gh_repo_id}`,
        method: "POST",
      }),
    }),
    githubPostClone: build.mutation<Repo, PostCloneParams>({
      query: (body) => ({
        url: `${body.project_id}/clone`,
        method: "POST",
        body,
      }),
    }),
  }),
})

export const githubAuthUrl = "/api/github/authorize"
export const {
  useGetGithubRepositoriesQuery,
  usePostProjectGithubRepoMutation,
  useGithubPostCloneMutation,
} = githubApi
